import { defineStore } from 'pinia';

export const useStoreRouter = defineStore('eatery-router', {
  persist: false,
  state: () => ({
    route: null,
    router: null,
  }),
});